<template>
  <!-- <div class=""> -->
    <!-- <div class=""> -->
      <div class="row m-0">
        <div class="col-4">

        </div>
        <div class="col-4">

        </div>
        <div class="col-4 pr-0 align-self-center">

          <div class="row justify-content-center m-0 mt-9">
            <div class="col-md-8 offset-md-2 pr-0">
              <router-link to="/commercial">
                <base-button
                  size="sm"
                  class="btn-customorange"
                  type="light">
                  <img src="img/icons/ButtonsIconsArcadisHub/btn_commercial.png">
                </base-button>
              </router-link>
              <label class="font-weight-bold text-dark">&nbsp;COMMERCIAL</label>
              <br><br>
              <router-link to="/management">
                <base-button
                  size="sm"
                  class="btn-customorange">
                  <img src="img/icons/ButtonsIconsArcadisHub/btn_management.png">
                </base-button>
              </router-link>
              <label class="font-weight-bold text-dark">&nbsp;MANAGEMENT</label>
              <br><br>
              <router-link to="/collaboration">
                <base-button
                  size="sm"
                  class="btn-customorange">
                  <img src="img/icons/ButtonsIconsArcadisHub/btn_collab.png">
                </base-button>
              </router-link>
              <label class="font-weight-bold text-dark">&nbsp;COLLABORATION</label>
              <br><br>
              <router-link to="/design">
                <base-button
                  size="sm"
                  class="btn-customorange">
                  <img src="img/icons/ButtonsIconsArcadisHub/btn_design.png">
                </base-button>
              </router-link>
              <label class="font-weight-bold text-dark">&nbsp;DESIGN</label>
              <br><br>
              <router-link to="/reporting">
                <base-button
                  size="sm"
                  class="btn-customorange">
                  <img src="img/icons/ButtonsIconsArcadisHub/btn_reporting.png">
                </base-button>
              </router-link>
              <label class="font-weight-bold text-dark">&nbsp;REPORTING</label>
              <br><br>
              <router-link to="/innovation">
                <base-button
                  size="sm"
                  class="btn-customorange">
                  <img src="img/icons/ButtonsIconsArcadisHub/btn_innovation.png">
                </base-button>
              </router-link>
              <label class="font-weight-bold text-dark">&nbsp;INNOVATION</label>
            </div>
          </div>

          <!-- <div class="">
            <router-link to="/collaboration">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_collab.png" class="categoryImage" title="Collaboration">
            </router-link>
          </div>

          <br>
          <br>
          <br>
          <div class="">
            <router-link to="/innovation">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_innovation.png" class="categoryImage1" title="Innovation">
            </router-link>
          </div> -->

          <!-- <div class="">
            <router-link to="/collaboration">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_collab.png" class="categoryImage" title="Collaboration">
            </router-link>
            COMMERCIAL
          </div>
          <div class="">
            <router-link to="/innovation">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_innovation.png" class="categoryImage" title="Innovation">
            </router-link>
          </div>
          <div class="">
            <router-link to="/reporting">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_reporting.png" class="categoryImage" title="Reporting">
            </router-link>
          </div>
          <div class="">
            <router-link to="/design">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_design.png" class="categoryImage" title="Design">
            </router-link>
          </div>
          <div class="">
            <router-link to="/management">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_management.png" class="categoryImage" title="Management">
            </router-link>
          </div>
          <div class="">
            <router-link to="/commercial">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_commercial.png" class="categoryImage" title="Commercial">
            </router-link>
          </div> -->
        </div>
        <!-- <div class="col-12">
          <div class="div-colab">
            <router-link to="/collaboration">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_collab.png" class="categoryImage" title="Collaboration">

            </router-link>
          </div>
          <div class="div-innovation">
            <router-link to="/innovation">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_innovation.png" class="categoryImage" title="Innovation">
            </router-link>
          </div>
          <div class="div-report">
            <router-link to="/reporting">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_reporting.png" class="categoryImage" title="Reporting">
            </router-link>
          </div>
          <div class="div-design">
            <router-link to="/design">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_design.png" class="categoryImage" title="Design">
            </router-link>
          </div>
          <div class="div-management">
            <router-link to="/management">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_management.png" class="categoryImage" title="Management">
            </router-link>
          </div>
          <div class="div-commercial">
            <router-link to="/commercial">
              <img src="img/icons/ButtonsIconsArcadisHub/btn_commercial.png" class="categoryImage" title="Commercial">
            </router-link>
          </div>
        </div>-->
      </div>
    <!-- </div> -->
    <!-- <div class="bg_gradient row">
    </div> -->
  <!-- </div> -->

</template>

<script>
// import VueFrame from 'vue-frame'
export default {
  name: 'LandingPageNew',
  components: {
    // VueFrame
  },
  data() {
    return {
      links: {
        collab: ""
      },
      accessToken: ""
    }
  },
}
</script>

<style scoped>

.div-colab {
  z-index: 10;
  position: absolute;
  top: 350px;
  left: 505px;
}
.div-innovation {
  position: absolute;
  z-index: 1;
  top: 528px;
  left: 562px;
}
.div-report {
  z-index: 10;
  position: absolute;
  top: 528px;
  left: 1033px;
}
.div-design {
  z-index: 10;
  position: absolute;
  top: 50px;
  left: 1300px;
}
.div-management {
  z-index: 10;
  position: absolute;
  top: 201px;
  left: 1027px;
}
.div-commercial {
  position: absolute;
  z-index: 1;
  top: 372px;
  left: 1238px;
}
.my-auto {
  margin-top: auto;
margin-bottom: auto;
}

/* CENTERED BG */
/* .div-colab {
  z-index: 10;
  position: absolute;
  top: 350px;
  left: 636px;
}
.div-innovation {
  top: 528px;
  position: absolute;
  z-index: 1;
  left: 694px;
}
.div-report {
  z-index: 10;
  position: absolute;
  top: 528px;
  left: 1163px;
}
.div-design {
  z-index: 10;
  position: absolute;
  top: 50px;
  left: 1430px;
}
.div-management {
  z-index: 10;
  position: absolute;
  top: 201px;
  left: 1157px;
}
.div-commercial {
  position: absolute;
  z-index: 1;
  top: 372px;
  left: 1368px;
} */
</style>
